<template>
    <div class="event-evaluation">
        <div class="event-question">
            <div class="question_main">
                <div class="question_title fl">
                    <div class="item-title">
                        <p class="normal fl">请输入您想要回测的事件：&nbsp;&nbsp;</p>
                        <p class="highlight fl" ref="sentenceNotice" style="display: none">事件不能为空!</p>
                    </div>
                    <div class="item-input">
                        <input
                            ref="question_sentence_input"
                            type="text"
                            class="question_sentence_input"
                            placeholder="请输入回测事件"
                            v-model="sentence"
                            @keyup="questionDataValidation($event.target, 1)"
                            @blur="questionDataValidation($event.target, 0)"
                            @keyup.enter="startBacktest"
                            v-validate="{type: 'string', max: 200, min: 1, errClass:'question_sentence_input focus', errRef: 'sentenceNotice'}">
                    </div>
                </div>

                <div class="question_sentence fl">
                    <div class="item-title">
                        <p class="normal fl">对应标的：&nbsp;&nbsp;</p>
                        <p class="highlight fl" ref="standardNotice" style="display: none">标的不能为空！</p>
                    </div>
                    <div class="item-input" style="position: relative;">
                        <input
                            ref="question_sentence_input_1"
                            type="text"
                            class="question_sentence_input standard"
                            placeholder="请输入对应标的"
                            v-model.trim="refZhishu"
                            @keyup="debounceSearchSharesFlag($event)"
                            @blur="buriedPoints"
                            @keyup.enter="startBacktest"
                            v-validate="{type: 'string', max: 200, min: 1, errClass:'question_sentence_input standard focus', errRef: 'standardNotice'}">

                        <key-list
                            v-if="isshowflaglist"
                            :list-visible.sync="isshowflaglist"
                            :list-data="sharesFlagList"
                            :parse-item="parseItem"
                            value-key="label"
                            @click-item="updateInput"
                            @select-item="updateInput"
                            @no-checked="nochecked">
                        </key-list>
                    </div>
                </div>
                <div class="question_cycle">
                    <p class="fl">您要看历史上事件发生后几天的情况：&nbsp;&nbsp;</p>
                    <p class="fl" ref="numberNotice" style="display: none">请正确输入正数，可用英文状态下&nbsp;","&nbsp;分隔天数</p>
                </div>
                <div class="question_cycle_number">
                    <input
                        ref="question_cycle_input"
                        type="text"
                        class="question_cycle_input"
                        v-model="number"
                        @blur="questionCyclePoint"
                        @keyup="validateInput"
                        @keyup.enter="startBacktest"
                        v-validate="{ type: 'period', errClass: 'question_cycle_input focus', errRef: 'numberNotice'}">
                    <span>&nbsp;&nbsp;天</span>
                </div>
                <div class="question_section">
                    <p class="fl">您要看历史上多少时间范围内的情况：&nbsp;&nbsp;</p>
                </div>
                <div class="sd-toolbar">
                    <div class="sd-toolbar_operabox">
                        <input id="trade_detail_startDate" type="text" readonly="readonly" class="trade_detail_startDate" v-model="tradeStartDate" @click="showTradeDateDialog($event, '#F{$dp.$D(\'trade_detail_endDate\')}', '2000-1-1')" @blur="startDatePoint" @keyup.enter="startBacktest">
                        <span class="time-split">&nbsp;至&nbsp;</span>
                        <input id="trade_detail_endDate" type="text" readonly="readonly" class="trade_detail_endDate" v-model="tradeEndDate" @click="showTradeDateDialog($event, yesterdayDate, '#F{$dp.$D(\'trade_detail_startDate\')}')" @blur="endDatePoint" @keyup.enter="startBacktest">
                    </div>
                </div>
                <div class="beginbacktest-s">
                    <span v-show="isbacktestdoneshow">回测运行完成 !</span>
                    <div v-if="!defaultqueryLoading" class="beginbacktest" @click="startBacktest">{{backtestText ? '启动回测' : '再次回测'}}</div>
                </div>
            </div>
        </div>
        <div class="report_grade" v-if="isreportgradeshow">
            <div class="report_grade_title">
                <p>报告评级</p>
            </div>
            <div class="report_grade_main">
                <div class="history_happen">
                    <p>历史发生次数</p>
                    <p>{{historyCount}} 次</p>
                </div>
                <div class="average_rise_fall">
                    <p>最优平均涨跌幅</p>
                    <p>{{averageRiseFall | safePercentFixedTwo}}</p>
                </div>
                <div class="max_win_rise">
                    <p>最大上涨概率</p>
                    <p>{{riseProbability | safePercentFixedTwo}}</p>
                </div>
            </div>
        </div>
        <div class="event-list" v-if="iseventlistshow">
            <div class="event-list_title">
                <p>事件列表 </p>
            </div>
            <div class="event-list_main">
                <table cellspacing="0">
                    <thead>
                        <tr>
                            <th v-for="(item, index) in eventTitleList" :key="index" :style="{width: 100 / Object.keys(eventTitleList).length + '%'}">{{item}}</th>
                        </tr>
                    </thead>
                </table>
                <EasyScrollbar :barOption="myBarOption">
                    <div class="rolltable">
                        <table cellspacing="0">
                            <tbody>
                                <tr v-for="(event, index) in eventDataList" :key="index" :class="(index + 1) % 2 === 0 ? 'gray' : ''">
                                    <td v-for="(item, key) in eventDataList[index]" :key="key" :class="item | eventFallClass" :style="{width : 100 / Object.keys(eventDataList[index]).length + '%'}">{{item | eventNumberFixed}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </EasyScrollbar>
            </div>
        </div>
        <div class="hotbacktest">
            <div class="hotbacktest_title">
                <p>热门回测</p>
            </div>
            <div class="hotbacktest_main">
                <div class="hotbacktest_left">
                    <div class="hotbacktest_name" v-for="(item, key) in leftRecommandBacktest" :key="'er' + key">
                        <p :title="item.query">{{ item.query }}</p>
                        <a :href="'#/eventevaluation?query=' + encodeURIComponent(item.query)"><span @click="hotBacktestPoint">回测一下</span></a>
                    </div>
                </div>
                <div class="hotbacktest_right">
                    <div class="hotbacktest_name" v-for="(item, key) in rightRecommandBacktest" :key="'er' + key">
                        <p :title="item.query">{{ item.query }}</p>
                        <a :href="'#/eventevaluation?query=' + encodeURIComponent(item.query)"><span @click="hotBacktestPoint">回测一下</span></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="testmain" v-show="isshowtestloading">
            <div class="testshadow"></div>
            <div class="testparallel">
                <div class="test-loading">
                    <span class="testing-icon"></span>
                    <span>正在为您计算，请耐心等待……</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-new */
    import {showTradeDateDialog} from '@/lib/wDatePicker.js'
    import axios from 'axios'
    import { debounce } from 'lodash'
    import keyList from '../lib/key-list'

    export default {
        name: 'eventevaluation',
        components: {
            'key-list': keyList
        },
        data () {
            var yesDate = this._getNowDate()
            var self = this
            var debounceSearchSharesFlag = debounce(function () {
                self.searchSharesFlag(...arguments)
            }, 500)
            return {
                debounceSearchSharesFlag,
                myBarOption: {
                    barWidth: 9, // 滚动条宽度
                    barMarginRight: 3 // 垂直滚动条距离整个容器右侧距离单位
                },
                backtestText: true,
                recommandBacktest: [],
                defaultQuery: {},
                defaultqueryLoading: true,
                sentence: '',
                defaultRefZhishu: '',
                refZhishu: '',
                number: '',
                tradeStartDate: '',
                tradeEndDate: '',
                yesterdayDate: yesDate,
                eventDataList: [],
                eventTitleList: [],
                sharesFlagList: [],
                historyCount: '',
                averageRiseFall: '',
                riseProbability: '',
                iseventlistshow: false,
                isbacktestdoneshow: false,
                isreportgradeshow: false,
                isshowflaglist: false,
                isshowtestloading: false,
                filterKey: [ 37, 38, 39, 40, 13 ],
                paramKeys: {
                    'query': 'sentence',
                    'refZhishu': 'refZhishu',
                    'daysForSaleStrategy': 'number',
                    'endDate': 'tradeEndDate',
                    'startDate': 'tradeStartDate'
                }
            }
        },
        computed: {
            buriedPoint () {
                return this.$buriedPoint.eventEvaluation
            },
            totalPoint () {
                return this.$buriedPoint.totalPlatformAccess
            },
            leftRecommandBacktest () {
                let data = []
                this.recommandBacktest.forEach((item, key) => {
                    if (key % 2 === 0) {
                        data.push(item)
                    }
                })
                return data
            },
            rightRecommandBacktest () {
                let data = []
                this.recommandBacktest.forEach((item, key) => {
                    if (key % 2 === 1) {
                        data.push(item)
                    }
                })
                return data
            }
        },
        methods: {
            validateInput () {
                this.number = this.number.replace(/，/, ',')
            },
            parseItem (item) {
                return item.code + ' ' + item.name
            },
            hotBacktestPoint () {
                window.TA.log({id: this.buriedPoint.hotBacktest, _sid: '__ths_003'})
            },
            startDatePoint () {
                window.TA.log(this.buriedPoint.startDate)
            },
            endDatePoint () {
                window.TA.log(this.buriedPoint.endDate)
            },
            questionCyclePoint () {
                window.TA.log(this.buriedPoint.holdingCycle)
            },
            buriedPoints () {
                window.TA.log(this.buriedPoint.modifySubject)
            },
            showTradeDateDialog,
            questionDataValidation (even, num) {
                let val = even.value
                if (this.sentence.length > 200) {
                    this.sentence = val.substr(0, 200)
                }
                if (num === 0) {
                    window.TA.log(this.buriedPoint.modifyQuestion)
                }
            },
            _getNowDate () {
                var now = new Date()
                now.setDate(now.getDate() - 1) // 获取昨天时间
                var month = now.getMonth() + 1
                month = month < 10 ? '0' + month : month
                var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
                var nowDate = now.getFullYear() + '-' + month + '-' + date
                return nowDate
            },
            requestSpellSearch () {
                let spell = this.refZhishu.split(' ')[0]
                return axios.get('/eventbacktest/spellsearch?query=' + spell).then((res) => {
                    return res.data.result
                })
            },
            searchSharesFlag (event) {
                var self = this
                if (!this.refZhishu) {
                    return false
                } else {
                    if (this.filterKey.indexOf(event.keyCode) > -1) {
                        return
                    }

                    this.requestSpellSearch().then((data) => {
                        this.sharesFlagList = data.map(item => ({ ...item, label: this.parseItem(item) }))
                        if (this.sharesFlagList.length === 0) {
                            this.isshowflaglist = false
                        } else {
                            this.isshowflaglist = true
                        }

                        this.defaultRefZhishu = this.refZhishu
                    }).catch(function (error) {
                        self.$tip({
                            message: error ? error.message : '网络异常',
                            duration: 2000,
                            type: 'error'
                        })
                    })
                }
            },
            updateInput (item) {
                this.refZhishu = this.parseItem(item)
            },
            nochecked () {
                this.refZhishu = this.defaultRefZhishu
            },
            sortNumber (a, b) {
                return a - b
            },
            startBacktest () {
                if (this.isshowflaglist) {
                    this.isshowflaglist = false
                    return
                }
                window.TA.log(this.buriedPoint.startUpBacktest)
                var self = this
                this.$nextTick(() => {
                    if (!this.$refs.question_sentence_input.validate() ||
                        !this.$refs.question_sentence_input_1.validate() ||
                        !this.$refs.question_cycle_input.validate()) {
                        return
                    }
                    this.isshowtestloading = true

                    this.requestSpellSearch().then((data) => {
                        if (data.length === 0) {
                            self.$tip({
                                message: '对应标的错误',
                                duration: 2000,
                                type: 'error'
                            })
                            this.isshowtestloading = false
                        } else {
                            this.defaultRefZhishu = this.parseItem(data[0])
                            this.refZhishu = this.defaultRefZhishu
                            let indexCode = data[0]['code']

                            let numberArry = Array.from(new Set(self.number.split(',').sort(this.sortNumber)))
                            self.number = numberArry.join(',')
                            axios.post('/eventbacktest/backtest', {
                                query: this.sentence,
                                period: self.number,
                                start_date: this.tradeStartDate,
                                end_date: this.tradeEndDate,
                                index_code: indexCode
                            }).then((res) => {
                                return res.data
                            }).then((data) => {
                                if (data.errorcode) {
                                    throw Error(data.errormsg)
                                } else {
                                    this.iseventlistshow = true
                                    this.isbacktestdoneshow = true
                                    this.isreportgradeshow = true
                                    this.backtestText = false
                                    this.isshowtestloading = false
                                    this.eventTitleList = data.result.title
                                    this.eventDataList = data.result.data
                                    this.historyCount = data.result.reportData.maxTotalCount
                                    this.averageRiseFall = data.result.reportData.maxChangeRate
                                    this.riseProbability = data.result.reportData.maxWinRate

                                    location.hash = '#/eventevaluation?query=' + encodeURIComponent(this.sentence) + '&refZhishu=' + encodeURIComponent(this.refZhishu) + '&daysForSaleStrategy=' + this.number + '&startDate=' + this.tradeStartDate + '&endDate=' + this.tradeEndDate
                                }
                            }).catch(function (error) {
                                self.iseventlistshow = false
                                self.isbacktestdoneshow = false
                                self.isreportgradeshow = false
                                self.backtestText = true
                                self.isshowtestloading = false
                                self.$tip({
                                    message: (error ? error.message : '网络异常'),
                                    duration: 2000,
                                    type: 'error'
                                })
                            })
                        }
                    }).catch(function (error) {
                        this.isshowtestloading = false
                        self.$tip({
                            message: error ? error.message : '网络异常',
                            duration: 2000,
                            type: 'error'
                        })
                    })
                })
            },
            startBacktestByRoute (routeParam) {
                var self = this
                var hasChanged = false
                for (let key in this.paramKeys) {
                    if (routeParam.hasOwnProperty(key) && routeParam[key] !== '' && self[self.paramKeys[key]] !== routeParam[key]) {
                        self[self.paramKeys[key]] = routeParam[key]
                        hasChanged = true
                    }
                }

                if (!self.isreportgradeshow || hasChanged) {
                    this.startBacktest()
                }
            },
            // __scrollBar__ () {
            //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            //     if (document.documentElement.scrollHeight === document.documentElement.clientHeight + scrollTop) {
            //         window.TA.log(this.buriedPoint.scrollBar)
            //     }
            // },
            initParams () {
                if (this.defaultQuery) {
                    this.number = this.defaultQuery.daysForSaleStrategy
                    this.sentence = this.defaultQuery.query
                    this.refZhishu = this.defaultQuery.refZhishu
                    this.tradeStartDate = this.defaultQuery.startDate
                    this.tradeEndDate = this.defaultQuery.endDate
                } else {
                    this.number = ''
                    this.sentence = ''
                    this.refZhishu = ''
                    this.tradeStartDate = ''
                    this.tradeEndDate = ''
                }
            }
        },
        // beforeDestroy () {
        //     window.removeEventListener('scroll', this.__scrollBar__)
        // },
        activated () {
            var self = this
            // window.addEventListener('scroll', self.__scrollBar__)
            window.TA.log({id: self.buriedPoint.pageAccess, _sid: '__ths_001'})
            window.TA.log({id: self.totalPoint, _sid: '__ths_002'})
        },
        deactivated () {
            // 重置初始化状态
            this.initParams()
            this.backtestText = true
            this.eventDataList = []
            this.eventTitleList = []
            this.sharesFlagList = []
            this.historyCount = ''
            this.averageRiseFall = ''
            this.riseProbability = ''
            this.iseventlistshow = false
            this.isbacktestdoneshow = false
            this.isreportgradeshow = false
            this.isshowflaglist = false
            this.isshowtestloading = false

            this.$refs.question_sentence_input.className = 'question_sentence_input'
            this.$refs.question_sentence_input_1.className = 'question_sentence_input standard'
            this.$refs.question_cycle_input.className = 'question_cycle_input'
            this.$refs.sentenceNotice.style.display = 'none'
            this.$refs.standardNotice.style.display = 'none'
            this.$refs.numberNotice.style.display = 'none'
        },
        mounted () {
            var self = this
            document.body.addEventListener('click', function () {
                self.isshowflaglist = false
            })
            this.defaultqueryLoading = true
            axios.get('/backtestonce/defaultquery?type=3').then((res) => {
                if (res.data.result) {
                    self.defaultQuery = res.data.result
                    self.initParams()
                }

                self.defaultqueryLoading = false
                if (JSON.stringify(self.$route.query) !== '{}') {
                    self.startBacktestByRoute(self.$route.query)
                }
            }).catch(function (error) {
                self.defaultqueryLoading = false
                self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
            })

            axios.get('/backtestonce/backtestexample?num=10&type=eventbacktest').then((res) => {
                self.recommandBacktest = res.data.result
            }).catch(function (error) {
                self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
            })
        },
        watch: {
            '$route' (newRoute, oldRoute) {
                if (this.defaultqueryLoading) {
                    return
                }

                if (newRoute.name === 'eventevaluation') {
                    let params = newRoute.query
                    if (newRoute.name === oldRoute.name) {
                        this.startBacktestByRoute(params)
                    } else {
                        if (JSON.stringify(params) !== '{}') {
                            this.startBacktestByRoute(params)
                        }
                    }
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/eventevaluation/main.scss';
</style>



// WEBPACK FOOTER //
// src/components/eventevaluation/index.vue